export default "__VITE_ASSET__5zd0SmHD__"